module.exports = __webpack_public_path__ + "img/Weapon_65.fa3f00f2.png";